import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "sidebar"]

  open() {
    this.overlayTarget.classList.remove("hidden")
  }

  close() {
    this.overlayTarget.classList.add("hidden")
  }
}
